export const paths = ['/drawings'];
